import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{attrs:{"justify":"center","align":"center"}},[_c('div',[_c(VAlert,{attrs:{"outlined":"","color":"warning","icon":"mdi-information"}},[_vm._v(" "+_vm._s(this.$t('pages.viewNotFound.info'))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }